// extracted by mini-css-extract-plugin
export default {"btn":"RedBtnHov_btn__-qfX1"};